import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=2601713c&"
import script from "./departments.vue?vue&type=script&lang=js&"
export * from "./departments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports